<template>
  <div class="app">
    <el-container>
      <el-aside class="app-side app-side-left"
                :class="isCollapse ? 'app-side-collapsed' : 'app-side-expanded'">
        <div class="app-side-logo">
          <img src="@/assets/logo.png"
               :width="isCollapse ? '60' : '60'"
               height="60" />
        </div>
        <div>
          <!-- 我是样例菜单 -->
          <el-menu default-active="1"
        router
          class="el-menu-vertical-demo"
          @open="handleOpen"
          :collapse="isCollapse">
 <!-- <template v-for="route in $router.options.routes" >
      <template v-for="item in route.children" >
        <el-menu-item 
          :key="route.path + '/' + item.path"
          :index="item.path"
        >
          <i class="el-icon-menu"></i>
          <span slot="title">{{ item.name }}</span>
      </el-menu-item>
      </template>
  </template>-->
  <template v-for="item in roleMain">
     <el-menu-item 
          :key="'/main/' + item.jumpPath"
          :index="item.jumpPath"
        >
          <i class="el-icon-menu"></i>
          <span slot="title">{{ item.jurisdictionName }}</span>
      </el-menu-item>
  </template>
</el-menu>
        </div>
      </el-aside>

      <el-container>
        <el-header class="app-header">
          <div style="width: 60px; cursor: pointer;"
               @click.prevent="toggleSideBar">
            <i v-show="!isCollapse" class="el-icon-d-arrow-left"></i>
            <i v-show="isCollapse" class="el-icon-d-arrow-right"></i>
          </div>
          
          

          <div class="app-header-userinfo">
            <el-dropdown trigger="hover"
                         :hide-on-click="false">
              <span class="el-dropdown-link">
                {{ username }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>我的消息</el-dropdown-item>
                <el-dropdown-item @click.native="updatePassword">修改密码</el-dropdown-item>
                <el-dropdown-item divided
                                  @click.native="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>

        <el-main class="app-body">
              
          <template>
            <div style="overflow-y:auto;height:800px;">    
            <router-view/>
            </div>
          </template>
          
        </el-main>
      </el-container>
    </el-container>
    <!--修改-->
  <el-dialog title="修改密码" :visible="editUserForm" size="tiny" :modal-append-to-body='false' @close='closeDialog'>
  <el-form id="#editsForm" ref="editsForm" :model="editsForm" label-width="150px">
    
      
    
    <el-form-item label="原密码" prop="loginName">
      <el-input  v-model="editsForm.loginName" max-length="10" type="password"></el-input>
    </el-form-item>

    <el-form-item label="新密码" prop="loginPassword">
      <el-input  v-model="editsForm.loginPassword" max-length="10" type="password"></el-input>
    </el-form-item>
    <el-form-item label="确认密码" prop="newloginPassword">
      <el-input  v-model="editsForm.newloginPassword" max-length="10" type="password"></el-input>
    </el-form-item>
    
    <el-form-item>
      <el-button type="primary" @click="studentEdit()">确定</el-button>
      <el-button @click="editUserForm = false;">取消</el-button>
    </el-form-item>
  </el-form>
</el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Container',
  data() {    
    return {
      roleMain:[],
      editUserForm: false,
      username: '',
       editsForm:{
          loginName:'',
          loginPassword:'',
          newloginPassword:''
        },
      isCollapse: false,
      apiUrl:''
    }
  },
 created(){
 this.apiUrl = localStorage.aipUrl;
 this.getRoleMain();
 },
  methods: {
    getRoleMain(){
      this.axios({
          method:'post',         
          url:`${this.apiUrl}/manageRole/getMainByUser`,
          data: { 
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': sessionStorage.getItem("token")
          }
      }).then(res=>{                  
          if(res.data.stateCode==200){
             this.roleMain=res.data.data.roleMain;
             console.log("roleMain",this.roleMain); 
          }else{
            alert(res.data.msg);
          }
      }).catch(error=>{
          
      })
    },
    toggleSideBar() {
      this.isCollapse = !this.isCollapse
    },
    updatePassword(){
      this.editsForm={};
      this.editUserForm=true;
    },
    closeDialog(){
  this.editUserForm = false;
  
},
    //确定
 studentEdit(){
    let parameteList=this.editsForm;  
    let {loginName,loginPassword,newloginPassword} = parameteList;
//判断数据是否为空
    if(loginName==''||loginPassword==''||newloginPassword==''){
      this.$message.error('所有项不准为空')
    }else if(this.editsForm.loginPassword!=this.editsForm.newloginPassword){
      this.$message.error('两次密码不一致')

    }else{
//每一条都不为空时才向后台发送http请求
       this.axios({
          method:'post',         
          url:`${this.apiUrl}/manageUser/updatePassword`,
          data: {
            loginName: this.editsForm.loginName,
            loginPassword: this.editsForm.loginPassword
            

          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': sessionStorage.getItem("token")
          }
      }).then(res=>{                  
          if(res.data.stateCode==200){
             
             console.log(this.addsForm);
             
             this.editUserForm = false;
          }else{
            alert(res.data.msg);
          }
      }).catch(error=>{
          
      })

     
    }
},
    logout: function () {
      this.$confirm('确认退出?', '提示', {})
        .then(() => {
          sessionStorage.removeItem('user');
          this.$router.push('/');
        })
        .catch(() => { });
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
  },
  mounted: function () {
    let user = sessionStorage.getItem('user');
    if (user) {
      this.username = user;
    }
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/components.vue